var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpi-card"},[_c('div',{staticClass:"chart-box"},[_c('i',{staticClass:"kpi-icon",class:_vm.icon,style:({ color: _vm.color })})]),_c('div',{staticClass:"kpi-text"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.animatedValue))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }